// extracted by mini-css-extract-plugin
export default {"loadMore":"_38O09","loading":"_2noyA","sticky-banner":"_2gEqu","mobile":"_3wrId"};